import { render, staticRenderFns } from "./FlatSelect.vue?vue&type=template&id=7b36133c&scoped=true"
import script from "./FlatSelect.vue?vue&type=script&lang=ts"
export * from "./FlatSelect.vue?vue&type=script&lang=ts"
import style0 from "./FlatSelect.vue?vue&type=style&index=0&id=7b36133c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b36133c",
  null
  
)

export default component.exports